"use client"

// TEMPORARY MIGRATION CODE — remove with the rest of lib/migration/. See ./AGENTS.md.
//
// Redirects ClientConsole legacy hash links to PUBLIC web routes (the invite
// flow `/#/invite?token=…` and the password reset flow `/#/reset`) onto their
// path equivalents. Mounted at the app root so it fires wherever an
// unauthenticated visitor lands — the proxy sends `/` → `/login` and the
// client-only `#fragment` rides along. No-op without a legacy fragment. The
// public counterpart to HomeEntryRedirect, which handles authenticated
// org-scoped bookmarks. Token cleaning happens on the /invite page, not here
// (in the hash the token is percent-encoded).
import { useRouter } from "next/navigation"
import { useEffect } from "react"
import { trackLegacyHashRedirected } from "./analytics"
import { mapLegacyInviteHash } from "./mapLegacyInviteHash"
import { mapLegacyResetHash } from "./mapLegacyResetHash"

export const PublicLegacyHashRedirect = () => {
  const router = useRouter()

  useEffect(() => {
    const hash = window.location.hash
    const target = mapLegacyInviteHash(hash) ?? mapLegacyResetHash(hash)
    if (!target) return
    trackLegacyHashRedirected(hash.slice(1))
    // The path-based replace drops the legacy "#/…" fragment so this can't
    // re-fire.
    router.replace(target)
  }, [router])

  return null
}
